import { Hazard } from 'features/hazards/hazard.types';
import { GeoEventLinks } from 'features/geoEvents/components/GeoEventLinks';
import { InitialLocationList } from 'features/geoEvents/components/InitialLocationList';
import { RelatedGeoEvents } from '../RelatedGeoEvents';

type HazardStructuredInfoProps = {
  hazard: Hazard;
};

export const HazardStructuredInfo = (
  props: HazardStructuredInfoProps,
): JSX.Element => {
  const { hazard } = props;

  const parentIncidents = hazard.parentGeoEvents ?? [];
  const links = hazard.data?.links ?? [];

  return (
    <>
      {parentIncidents.length > 0 && (
        <RelatedGeoEvents geoEvents={parentIncidents} />
      )}
      <InitialLocationList
        coordinates={hazard}
        paywallSource="hazard_coordinates"
      />
      {links.length > 0 && <GeoEventLinks links={links} />}
    </>
  );
};
